window.Studio407 = window.Studio407 || {};

(function(Studio) {
  'use strict';

  Studio.destroyCropper = function() {
    if (window.studioCropper) {
      window.studioCropper.destroy();
      window.studioCropper = null;
    }
  };

  Studio.initCropper = function(image) {
    Studio.destroyCropper();

    window.studioCropper = new Cropper(image, {
      aspectRatio: 1,
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 1,
      background: false,
      responsive: true,
      zoomable: true,
      movable: true,
      rotatable: true
    });
  };

  Studio.openEditor = function(slotId) {
    const slot = Studio.state.slots[slotId];
    const editorImage = document.getElementById('studio-editor-image');

    if (!slot || !slot.image || !editorImage) return;

    Studio.state.activeSlot = slotId;
    editorImage.src = slot.image;

    Studio.showStep('editor');

    requestAnimationFrame(function() {
      window.setTimeout(function() {
        Studio.initCropper(editorImage);
      }, 50);
    });
  };

  Studio.saveEditorImage = function() {
    if (Studio.state.activeSlot === null) return;

    const slot = Studio.state.slots[Studio.state.activeSlot];

    if (!slot || !window.studioCropper) return;

    const canvas = window.studioCropper.getCroppedCanvas({
      maxWidth: 2400,
      maxHeight: 2400,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high',
      fillColor: '#ffffff'
    });

    if (!canvas) {
      alert('We could not prepare this photo. Please try again.');
      return;
    }

    canvas.toBlob(
      function(blob) {
        if (!blob) {
          alert('We could not save this photo. Please try again.');
          return;
        }

        const fileName = `407-magnet-${Studio.state.activeSlot + 1}.jpg`;

        slot.finalFile = new File([blob], fileName, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });

        Studio.revokePreviewUrl(slot.image);

        slot.image = URL.createObjectURL(blob);
        slot.edited = true;

        Studio.destroyCropper();
        Studio.renderGallery();
        Studio.showStep('gallery');
      },
      'image/jpeg',
      0.98
    );
  };

  Studio.resetEditorImage = function() {
    if (Studio.state.activeSlot === null) return;

    const slot = Studio.state.slots[Studio.state.activeSlot];
    const editorImage = document.getElementById('studio-editor-image');

    if (!slot || !slot.originalImage || !editorImage) return;

    Studio.revokePreviewUrl(slot.image);

    slot.image = slot.originalImage;
    slot.finalFile = null;
    slot.edited = false;

    editorImage.src = slot.originalImage;

    requestAnimationFrame(function() {
      window.setTimeout(function() {
        Studio.initCropper(editorImage);
      }, 50);
    });
  };

  Studio.replaceEditorImage = async function(file) {
    if (!file || Studio.state.activeSlot === null) return;

    try {
      const imageData = await Studio.readFileAsDataURL(file);
      const slot = Studio.state.slots[Studio.state.activeSlot];
      const editorImage = document.getElementById('studio-editor-image');

      if (!slot || !editorImage) return;

      Studio.revokePreviewUrl(slot.image);

      slot.originalFile = file;
      slot.originalImage = imageData;
      slot.image = imageData;
      slot.finalFile = null;
      slot.edited = false;

      editorImage.src = imageData;

      requestAnimationFrame(function() {
        window.setTimeout(function() {
          Studio.initCropper(editorImage);
        }, 50);
      });
    } catch (error) {
      console.error(error);
      alert('We could not replace this photo. Please try again.');
    }
  };
})(window.Studio407);
